<template>
  <v-card elevation="1" class="mb-4 grey lighten-4" color="grey lighten-5">
    <v-card-text>
      <h6 class="text-h6 black--text">Escaner IA<v-chip class="ml-3" color="primary"> Nuevo </v-chip> <v-chip outlined
          class="ml-1"> Beta Version </v-chip></h6>
      <p class="text-body-2">Procesa tu comprobante con Inteligencia Artificial y carga los datos en forma automatica
      </p>
      <p class="caption">Solo admite formato PDF</p>
      <v-row>
        <v-col md="4">
          <v-file-input filled dense label="Seleccionar comprobante" name="invoice_file" ref="invoice_file_ref"
            v-model="invoice_file"></v-file-input>
        </v-col>
        <v-col md="2">
          <v-btn @click="readInvoice()" class="mt-3 text-white" color="blue-grey" small :loading="loading">
            Procesar</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <DialogYesNo :open="showConfirmDialog" title="Adjuntar comprobante"
      message="¿Desea utilizar este documento como comprobante asociado al gasto?" @cancel="cancelConfirm"
      @accept="confirmFileAttachment" />
  </v-card>
</template>
<script>
import DialogYesNo from "@/components/DialogYesNo.vue";
import { spentService } from "@/libs/ws/spentService";
import { fileUtils } from "@/libs/utils/fileUtils";
export default {
  components: { DialogYesNo },
  props: {
    setInvoice: Function,
    open: Boolean,
    item: Object
  },
  data: () => ({
    invoice: null,
    invoice_file: null,
    loading: false,
    showConfirmDialog: false,
    pendingBase64: null,
  }),
  watch: {
    open(val) {
      if (val) {
        this.invoice_file = null;
      }
    },
  },
  mounted() { },
  methods: {
    async readInvoice() {
      if (!(this.invoice_file instanceof File)) {
        this.$toast.error("Debe seleccionar un archivo", "Error");
        return;
      }

      if (this.loading) return;

      this.loading = true;
      const b64file = await fileUtils.toBase64(this.invoice_file);

      if (!this.item.file && !this.item.file_base64) {
        this.pendingBase64 = b64file;
        this.showConfirmDialog = true;
        this.loading = false;
        return;
      }

      this.procesarLectura(b64file);
    },
    async procesarLectura(b64file) {
      this.loading = true;
      spentService
        .readInvoice({ invoice_b64: b64file })
        .then((response) => {
          if (response.status) {
            this.$emit("setInvoice", response.result);
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelConfirm() {
      this.showConfirmDialog = false;      
    },
    confirmFileAttachment() {
      this.item.file_base64 = this.pendingBase64;
      this.item.name_file = this.invoice_file.name;
      this.showConfirmDialog = false;
      this.procesarLectura(this.pendingBase64);
    },
  },
};
</script>
